
export { localStorageUtils } from "/codebuild/output/src4122767702/src/packages/utils/src/storage/index.ts"